import ApplicationsSection from './ApplicationsSection'
import Box from '@mui/material/Box'
import Checkbox from '@mui/material/Checkbox'
import ContactInfo from './ContactInfo'
import FormControlLabel from '@mui/material/FormControlLabel'
import { Grid } from '@mui/material'
import Radio from '@mui/material/Radio'
import React from 'react'
import styled from 'styled-components'

const SearchResultContainer = styled(Grid)`
	display: inline-flex;
	margin-bottom: 1.875rem;
`

const AccountInformation = styled(Box)`
	display: inline-flex;
	border: 0.0625rem solid rgba(0, 0, 0, 0.12);
	box-sizing: border-box;
	border-radius: 0.25rem;
`

const FormItem = styled(Grid)`
	align-self: center;
	text-align: center;
`

const FormButton = styled(FormControlLabel)`
	display: inline-block;
	width: fit-content;
	margin: 0px;
`

const SearchResultCard = ({ profile, isSelected, isChecked, onChange }) => {
  const applicationArray = [...profile.applications]
  const slicedApplications = applicationArray.slice(0, 3)

  return (
    <SearchResultContainer container>
      <Grid item xs={8}>
        <AccountInformation>
          <ContactInfo item profile={profile} />
          <ApplicationsSection applicationsInfo={slicedApplications} item />
        </AccountInformation>
      </Grid>

      <FormItem item xs={2}>
        <FormButton
          aria-checked={isSelected}
          aria-label={profile.profileId}
          checked={isSelected}
          control={
            <Radio color="primary" data-testid={`radio-${profile.profileId}`} />
          }
          key={profile.profileId}
          label=""
          value={profile.profileId}
        />
      </FormItem>

      <FormItem item xs={2}>
        <FormButton
          checked={isChecked}
          control={
            <Checkbox
              color="primary"
              data-testid={`checkbox-${profile.profileId}`}
            />
          }
          disabled={isSelected}
          key={profile.profileId}
          label=""
          onChange={onChange}
          value={profile.profileId}
        />
      </FormItem>
    </SearchResultContainer>
  )
}

export default SearchResultCard
